import React from 'react';

import { Grid, TextField } from '@mui/material';
import { StyledSectionHeader } from '../styles';
import { COLORS } from '../../../utils/colors';

const HOME_ADDRESS_INFORMATION = [
  {
    label: 'Street address *',
    name: 'address',
    size: 6,
    disabled: false,
  },
  {
    label: 'City *',
    name: 'city',
    size: 6,
    disabled: false,
  },
  {
    label: 'Postal Code *',
    name: 'postalCode',
    size: 6,
    maxLength: 8,
    disabled: false,
  },
  {
    label: 'Province *',
    name: 'province',
    size: 6,
    disabled: false,
  },
  {
    label: 'Country *',
    name: 'country',
    size: 6,
    disabled: true,
  },
];

const HomeAddress = ({
  values,
  errors,
  handleChange,
  optionalAddress,
}: any) => {
  return (
    <Grid item xs={12} justifyContent="flex-end">
      <Grid item xs={12} mb={4} sx={{ ml: '-2rem' }}>
        <StyledSectionHeader>PROPERTY ADDRESS</StyledSectionHeader>
      </Grid>

      <Grid container spacing={4}>
        {HOME_ADDRESS_INFORMATION.map(
          ({ label, name, size, maxLength, disabled }) => {
            return (
              <Grid item xs={12} md={6} key={name}>
                <TextField
                  fullWidth
                  label={optionalAddress ? label?.replace('*', '') : label}
                  variant="outlined"
                  value={values[name]}
                  onChange={handleChange(name)}
                  error={!!errors[name]}
                  inputProps={{
                    maxLength: maxLength && maxLength,
                  }}
                  disabled={disabled}
                  helperText={
                    errors[name] ? (
                      <span style={{ color: COLORS.RED }}>{errors[name]}</span>
                    ) : (
                      name === 'country' &&
                      `This service is only available in Canada`
                    )
                  }
                />
              </Grid>
            );
          },
        )}
      </Grid>
    </Grid>
  );
};

export default HomeAddress;
